/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Player from 'components/Video/Video';
import useAnimation from './animations';
import './Video.scss';

/**
 * This is the Video component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Video({ video, title }) {
  const [ref] = useAnimation();

  return (
    <header ref={ref} className="header header-video">
      <Player {...video} />
      <h1>{title}</h1>
    </header>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Video.propTypes = {
  video: PropTypes.object,
  title: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Video.defaultProps = {
  video: {},
};

export default Video;
